var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"border-radius":"8px","height":"1069px"},attrs:{"color":"#FFFFFF","elevation":"1","width":"auto"}},[_c('CardExtratoTipoClienteMobile',{attrs:{"executa-skeleton":_vm.executaSkeleton,"dados":_vm.dados}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }